import React, { Component } from "react";
import { IoDocumentsSharp } from "react-icons/io5";
// import { MdOutlineFileDownload } from "react-icons/md";
import axios from "axios";
import { GrDocumentExcel } from "react-icons/gr";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { CiLock } from "react-icons/ci";


class AssignmentCourse extends Component {
    state = {
        course: [],
        enrolled: false,
    }
    handleAdddata = () => {
        const formcontainer = document.querySelector(".dash_add_course_cover.addassignment")
        formcontainer.style.display = "flex"
    }
    componentDidMount() {
        this.fetchCourses();
        this.fetchCourse()
    }
    componentDidUpdate(prevProps) {
        if (this.props.course_id !== prevProps.course_id) {
            this.fetchCourses();
            this.fetchCourse()
        }
        if (this.props.shouldRefresh && !prevProps.shouldRefresh) {
            this.fetchCourses();
            this.props.onRefreshDone(); // Call onRefreshDone after fetching
            this.fetchCourse()
        }
    }
    

    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            // const course_id = this.props.course_id
            // const courseId = parseInt(course_id, 10);
            let headers = {}; // Initialize an empty headers object

            if (accessToken) {
                headers = {
                    Authorization: `Bearer ${accessToken}`,
                };
            }

            const response = await axios.get(`https://api.geoinfoacademy.com/api/capstone/`, {
                headers: headers,
            });
            this.setState({ course: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    fetchCourse = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const course_id = this.props.course_id
            const courseId = parseInt(course_id, 10);
          const response = await axios.get(`https://api.geoinfoacademy.com/api/courses/${courseId}/`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
          this.setState({ enrolled: response.data.enrolled });
          console.log("API Response in the review course paid:", response.data);
        } catch (error) {
          console.error("Error fetching data:", error);
          // Handle errors as needed
        }
      };





    handleDelete = async (docId) => {
        const accessToken = localStorage.getItem("accessToken");


        try {
            const response = await axios.delete(`https://api.geoinfoacademy.com/api/capstone/${docId.id}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 204 || response.status === 200) { // Check for successful delete status codes (204 No Content is common)
                console.log("Document deleted successfully:", docId.id);
                // Optionally: Refresh the document list after successful deletion
                this.fetchCourses(); // Or whatever method you use to refresh the list
                // You might also want to provide user feedback (e.g., a toast notification)
                // alert("Document deleted successfully")
            } else {
                console.error("Error deleting document:", response.status, response.data);
                // Handle error (e.g., display an error message to the user)
                alert("Error deleting document")

            }
        } catch (error) {
            console.error("Error deleting document:", error);
            // Handle network errors or other exceptions
            alert("Error deleting document")
        }
    };




    handleRedirect = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            // Navigate if already logged in
         
        try {
            const response = await axios.post(
                `https://api.geoinfoacademy.com/api/interested-courses/`,
                {
                    course_id: course_id, // Place course_id in the request body
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            console.log(response.data.message)
            window.location.href = `/description/${course_id}/paymentverify`; 
        }
        catch (error) {
            console.error("Error initiating payment:", error);
        }

    }else {
            localStorage.setItem('redirectCourseId', course_id); // Store course ID
            localStorage.setItem('redirectCourseaction', "apply");
            window.location.href = '/login'; // Redirect to login
        }
    };



    render() {
        const {course} = this.state
        // const document = this.state.course;
        // const doclist = document && document.documents && document.documents.length ? (
        //     document.documents.map((doc) => {
        //         const fileName = doc.file_path.substring(doc.file_path.lastIndexOf('/') + 1);
        //         const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1); // Extract the extension
        //         return (
        //             <li className="document" key={doc.id}>
        //                 <IoDocumentsSharp /> <span>{doc.title}</span> <span className="file-extension">{fileExtension}</span><button onClick={() => this.handleDownload(doc)} className="download"><MdOutlineFileDownload /></button>
        //             </li>
        //         );
        //     })
        // ) : (
        //     <li className="document">
        //         <GrDocumentExcel /> No Document
        //     </li>
        // );

        const documents = this.state.course; // The API response is already the array of documents
        const doclist = documents && documents.length ? (
            documents.map((doc) => {
                const fileName = doc.file.substring(doc.file.lastIndexOf('/') + 1); // Use doc.file here
                const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
                return (
                    <li className="document" key={doc.id}>
                        <IoDocumentsSharp /> <span>{doc.title}</span> <span className="file-extension">{fileExtension}</span><button onClick={() => this.handleDelete(doc)} className="download"><MdOutlineDeleteOutline /></button>
                    </li>
                );
            })
        ) : (
            <li className="document">
                <GrDocumentExcel /> No Document
            </li>
        );

        return (
            <section className="courseassignmnt">
                <h3>Assignment{this.state.enrolled === true ? <button onClick={this.handleAdddata}>Add</button>: ""}</h3>
                <div className="container">
                    {/* <li><IoDocumentsSharp /> <span>israel</span> <span className="file-extension">pdf</span><button onClick={() => this.handleDownload()} className="download"><MdOutlineFileDownload /></button></li> */}
                    
                    {this.state.enrolled ?
                            doclist :
                            <div className="enroll_error">
                                <div className="enroll_cover">
                                    <CiLock />
                                    <p>Enroll For Course To Gain Access</p>
                                    <button onClick={this.handleRedirect}>Apply For Course</button>
                                </div>
                            </div>
                        }
                </div>
            </section>
        ) 
    }
}

export default AssignmentCourse